// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes react-overlay-loader-spinner {
  to {
    transform: rotate(360deg);
  }
}

.react-overlay-loader-spinner:before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40px;
  height: 40px;
  margin-top: -30px;
  margin-left: -20px;
  border-radius: 50%;
  border: 3px solid #eee;
  border-top-color: #07d;
  animation: react-overlay-loader-spinner 0.8s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./../../../node_modules/react-overlay-loader/styles.css"],"names":[],"mappings":"AAAA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,4DAA4D;AAC9D","sourcesContent":["@keyframes react-overlay-loader-spinner {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.react-overlay-loader-spinner:before {\n  content: \"\";\n  box-sizing: border-box;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 40px;\n  height: 40px;\n  margin-top: -30px;\n  margin-left: -20px;\n  border-radius: 50%;\n  border: 3px solid #eee;\n  border-top-color: #07d;\n  animation: react-overlay-loader-spinner 0.8s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
